import React, { useRef, useState, useEffect } from 'react';
import {
  Dialog,
  Icon,
  Button,
  PopOver,
  OverlayTrigger,
} from '@tencent/spaui';
import _ from 'lodash';
import { ListView } from '@tencent/ptp-fe-common';

import '../../../../style/less/modules/qw-drainage.less';
import { RPCFactory } from '../../../utils/RequestUtil';
import { CorpSelector } from '../qw/corpSelector';
import { beaconInstance } from '../../../instrumentation/beaconSetup';

const List = (props) => {
  const lvRef = useRef();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [operateItem, setOperateItem] = useState({});

  const getList = (params) => new Promise((res) => {
    RPCFactory.qwDrainage.getList(params)
      .done((data) => {
        const list = (data.entities || []).map((item) => {
          const row = {
            ...item,
            _data: item,
            id: item.id,
            qrCode: item.qrCode,
            name: item.name,
            externalUserCount: item.externalUserCount,
            createdTime: item.createdTime,
            wxWorkUserIds: item.wxWorkUserIds || [],
            backupWxWorkUserId: item.backupWxWorkUserId || '',
          }
          return row;
        });
        const listData = {
          list,
          page_info: { total_number: _.get(data, 'page_info.total_number') || 0 },
        };
        res(listData);
      })
      .fail((ret, msg) => {
        res([]);
        window.alert(msg);
      });
  });

  const reloadList = () => {
    if (typeof lvRef.current.loadList !== 'function') return;
    lvRef.current.loadList();
  };

  // 展示的列
  const showColumns = [
    'qrCode',
    'name',
    'id',
    'externalUserCount',
    'createdTime',
    'wxWorkUserIds',
    'backupWxWorkUserId',
    'options',
  ];

  const downloadQrCode = (src, name = 'qrcode') => {
    const tag = document.createElement('a');
    fetch(src)
      .then((res) => res.blob())
      .then((blob) => {
        tag.href = URL.createObjectURL(blob);
        tag.download = name;
        tag.click();
      });
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
    setOperateItem({});
  };

  const deleteItem = (id) => {
    RPCFactory.qwDrainage.delete(id)
      .done(() => {
        cancelDelete();
        reloadList();
      })
      .fail((ret, msg) => {
        alert(msg);
        cancelDelete();
      });
  };

  const confirmDelete = () => {
    deleteItem(operateItem.id);
  };

  const handleCreate = () => {
    beaconInstance.onUserAction(
      'btn_click',
      { page: '渠道活码', name: '点击创建渠道活码按钮' },
    );
    props.history.push('/qw/acquisition/drainage/create');
  };

  // ----------------------- 列渲染方法 -----------------------
  // 二维码图
  const renderQrCode = (type, name, value) => {
    return (<img className="drainage-qrcode" src={value} />);
  }

  // 扫码添加次数
  const renderAddTime = (type, name, value) => {
    if (type !== 'head') return value;
    const popover = (
      <PopOver>
        统计截止目前添加该渠道活码的人次
      </PopOver>
    );
    return (
      <div>
        <span>{value}</span>
        <OverlayTrigger trigger="hover" delay={100} overlay={popover} placement="top">
          <i className="icon icon-help" />
        </OverlayTrigger>
      </div>
    );
  }

  // 使用成员
  const renderMember = (type, name, value) => {
    if (type === 'head') {
      const popover = (
        <PopOver>
          活码中设置的客服人员
        </PopOver>
      );
      return (
        <div>
          <span>{value}</span>
          <OverlayTrigger trigger="hover" delay={100} overlay={popover} placement="top">
            <i className="icon icon-help" />
          </OverlayTrigger>
        </div>
      );
    }
    const ids = Array.isArray(value) ? value : [];
    return ids.map((id) => (
      <span key={id} className="qw-user-name">
        <ww-open-data key={id} type="userName" openid={id} />
      </span>
    ));
  }

  // 备用成员
  const renderBackupMember = (type, name, value) => {
    if (type === 'head') {
      const popover = (
        <PopOver>
          当活码中所有客服人员无法接待时，启用该备用成员接待新客户
        </PopOver>
      );
      return (
        <div>
          <span>{value}</span>
          <OverlayTrigger trigger="hover" delay={100} overlay={popover} placement="top">
            <i className="icon icon-help" />
          </OverlayTrigger>
        </div>
      );
    }
    return (<ww-open-data type="userName" openid={value} />);
  }

  // 操作
  const renderOptions = (type, name, value, data) => {
    const handleDownloadQrCode = (e) => {
      e.preventDefault();
      downloadQrCode(data.qrCode, data.id);
    };

    const handleDelete = (e) => {
      e.preventDefault();
      setOperateItem(data._data);
      setShowDeleteConfirm(true);
    };

    const handleEdit = (e) => {
      e.preventDefault();
      props.history.push(`/qw/acquisition/drainage/edit/${data.id}`);
    };

    const handleDetail = (e) => {
      e.preventDefault();
      props.history.push(`/qw/acquisition/drainage/detail/${data.id}`);
    };

    return (
      <div>
        <a href="#" onClick={handleDetail}>详情</a>
        <a href="#" onClick={handleDownloadQrCode}>下载</a>
        <a href="#" onClick={handleEdit}>编辑</a>
        <a href="#" onClick={handleDelete}>删除</a>
      </div>
    );
  };
  // --------------------------------------------------------

  // 列渲染方法 map
  // 注意：使用的时候需要注入 name: [key] 属性
  const columnMap = {
    qrCode: { title: '二维码图', render: renderQrCode },
    name: { title: '渠道活码名称' },
    id: { title: '渠道活码ID' },
    externalUserCount: { title: '扫码添加次数', customRender: renderAddTime },
    createdTime: { title: '创建时间' },
    wxWorkUserIds: { title: '使用成员', customRender: renderMember },
    backupWxWorkUserId: { title: '备用成员', customRender: renderBackupMember },
    options: { title: '操作', render: renderOptions },
  };

  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        const obj = { ...params };
        delete obj.page_size;
        delete obj.page;
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },
    toolbarConfig: {
      left: (
        <div className="toolbar-left">
          <Button displayType="primary" onClick={handleCreate}>
            <Icon type="add" />
            <span>新增渠道活码</span>
          </Button>
        </div>
      ),
    },
    filterConfig: null,
    batchConfig: null,
    tableConfig: {
      defaultPageSize: 10,
      select: null,
      columns: showColumns.map(key => {
        return { ...columnMap[key], name: key };
      }),
      optionalConfig: {
        type: 'optional',
        target: 'wxWorkUserId',
        multiple: true,
        canOptional: true,
      },
    },
  });

  useEffect(() => {
    beaconInstance.onUserAction(
      'page_view',
      { page: '引流获客' },
    );
  }, []);

  return (
    <main id="main" className="main">
      <CorpSelector onChange={reloadList} />
      <div className="page-drainage">
        <div className="card borderd" style={{ paddingTop: 0 }}>
          <div className="datalist">
            <ListView
              className="lv"
              ref={lvRef}
              options={lvOptions}
            />
          </div>
        </div>
        <Dialog
          type="simple"
          show={showDeleteConfirm}
          title="确认删除吗？"
          onSubmit={confirmDelete}
          onCancel={cancelDelete}
          onClose={cancelDelete}
          style={{ width: 260 }}
        ></Dialog>
      </div>
    </main>
  );
};

export default List;
